import gql from 'graphql-tag';
import {ManagedByUserFullFragment} from "../fragments/ManagedByUserFullFragment";

export const ManagedByUserDetailQuery = gql`
	query ManagedByUserDetailQuery($id: ID!) {
		entity: node (id: $id) {
			...ManagedByUserFullFragment
		}
	}
	${ManagedByUserFullFragment}
`;


